<!-- Snow.vue -->
<template>
    <div ref="starRef" class="fixed inset-0 z-20 pointer-events-none"></div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';

const stars = 50;

const starRef = ref(null);

let cleanup = [];

onMounted(() => {
    const twHost = starRef.value;

    if (twHost) {
        for (let i = 0; i < stars; i++) {
            const t = document.createElement('div');
            t.className = 'star';
            t.style.left = Math.random() * 100 + 'vw';
            t.style.top = Math.random() * 40 + 'vh';
            t.style.animationDelay = Math.random() * 5 + 's';
            t.style.transform = `scale(${0.6 + Math.random() * 0.8})`;

            twHost.appendChild(t);
            cleanup.push(() => twHost.contains(t) && twHost.removeChild(t));
        }
    }
});

onBeforeUnmount(() => {
    cleanup.forEach((fn) => fn());
    cleanup = [];
});
</script>

<style scoped>
@keyframes star {
    0%,
    100% {
        opacity: 0.35;
        filter: drop-shadow(0 0 2px rgba(160, 210, 255, 0.5));
    }
    50% {
        opacity: 1;
        filter: drop-shadow(0 0 6px rgba(160, 210, 255, 0.9));
    }
}

:global(.star) {
    position: absolute;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background: rgba(200, 230, 255, 0.9);
    box-shadow: 0 0 8px rgba(170, 210, 255, 0.8);
    animation: star 2.8s ease-in-out infinite;
}
</style>
